"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Programs = exports.ProgramTag = exports.PluginContainer = exports.PageTitle = void 0;
require("@tcc/fds");
const PageTitle_1 = require("./components/PageTitle/PageTitle");
const PluginContainer_1 = require("./components/PluginContainer/PluginContainer");
const ProgramTag_1 = require("./components/ProgramTag/ProgramTag");
const programs_1 = require("./types/programs");
var PageTitle_2 = require("./components/PageTitle/PageTitle");
Object.defineProperty(exports, "PageTitle", { enumerable: true, get: function () { return PageTitle_2.PageTitle; } });
var PluginContainer_2 = require("./components/PluginContainer/PluginContainer");
Object.defineProperty(exports, "PluginContainer", { enumerable: true, get: function () { return PluginContainer_2.PluginContainer; } });
var ProgramTag_2 = require("./components/ProgramTag/ProgramTag");
Object.defineProperty(exports, "ProgramTag", { enumerable: true, get: function () { return ProgramTag_2.ProgramTag; } });
var programs_2 = require("./types/programs");
Object.defineProperty(exports, "Programs", { enumerable: true, get: function () { return programs_2.Programs; } });
exports.default = { PageTitle: PageTitle_1.PageTitle, PluginContainer: PluginContainer_1.PluginContainer, ProgramTag: ProgramTag_1.ProgramTag, Programs: programs_1.Programs };
